import TrustStack from '../TrustStack';
import type { TrustStack as TrustStackData } from '../../types';

interface VendorScoreCardProps {
  /** Public 300-900 score. */
  score: number;
  /** Risk-band label, e.g. "Strong Observed Performance". */
  statusLabel: string;
  /** Trust label payload — passes through to <TrustStack>. */
  trustStack: TrustStackData;
  /** Compact: drop the inline Trust Stack (used on dense embed surfaces). */
  variant?: 'full' | 'compact';
}

function tone(label: string): string {
  if (label === 'Strong Observed Performance') return 'text-emerald-600';
  if (label === 'Stable Observed Performance') return 'text-amber-600';
  return 'text-slate-600';
}

/**
 * Presentational score card extracted from PublicVendorProfile (per
 * Opus design review N1).  Embeddable on the marketing home page
 * without dragging the full profile layout, useParams, or the
 * document.title side-effect along with it.
 */
export default function VendorScoreCard({
  score, statusLabel, trustStack, variant = 'full',
}: VendorScoreCardProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="text-xs uppercase tracking-wide text-slate-400">
        GuardGrade Score
      </div>
      <div className="mt-2 flex items-baseline gap-3">
        <span className="text-5xl font-bold text-slate-900">{score}</span>
        <span className="text-sm text-slate-400">/ 900</span>
        <span className={`ml-auto text-sm font-semibold ${tone(statusLabel)}`}>
          {statusLabel}
        </span>
      </div>
      {variant === 'full' && (
        <div className="mt-4">
          <TrustStack data={trustStack} variant="compact" />
        </div>
      )}
    </div>
  );
}
